import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";

import auth from "./modules/auth";
import platform from "./modules/platform";
import company from "./modules/company";
import changelog from "./modules/changelog";

// DELETE
import largeSidebar from "./modules/largeSidebar";
import compactSidebar from "./modules/compactSidebar";
import themeConfig from "./modules/themeConfig";
import verticalSidebar from "./modules/verticalSidebar";
// DELETE

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
  modules: {
    auth,
    platform,
    company,
    changelog,
    largeSidebar,
    compactSidebar,
    themeConfig,
    verticalSidebar,
  },
  // Not persist changelog
  plugins: [createPersistedState({ storage: window.localStorage })],
});
